// LitAwards.js
import { Cards } from './Cards.js';
import './css/mycss.css';

import img1 from './images/a6.png';
import img2 from './images/a3.png';
import img3 from './images/a2.png';
import img4 from './images/l4.png';
import img5 from './images/l5.png';
import img6 from './images/l6.png';
import img7 from './images/l7.png';

/* ----------------- Export Data for Global Search ----------------- */

export const literatureAwardsData = [
  {
    category: "Literature",
    htext: "Jnanpith Award",
    ptext: "India’s highest literary honour for outstanding authorship.",
    img1,
    ialt: "Jnanpith Award",
    modalContent: `
      <b>Established:</b>1961</br>
      <b>Type:</b>National literary award</br>
      <b>First Awarded:</b>1965</br>
      <b>First Recipient:</b>G. Sankara Kurup (Malayalam)</br>
      <b>Awarded For:</b>Outstanding literary contribution</br>
      <a href='https://en.wikipedia.org/wiki/Jnanpith_Award'>Wiki Link</a>
    `
  },
  {
    category: "Literature",
    htext: "Sahitya Akademi Award",
    ptext: "The annual award honouring excellence in Indian literature across languages.",
    img1: img2,
    ialt: "Sahitya Akademi Award",
    modalContent: `
      <b>Established:</b>1954</br>
      <b>Type:</b>Annual national literary award</br>
      <b>First Awarded:</b>1955</br>
      <b>First Recipient:</b>Makhanlal Chaturvedi</br>
      <b>Awarded For:</b>Distinguished literary works</br>
      <a href='https://en.wikipedia.org/wiki/Sahitya_Akademi_Award'>Wiki Link</a>
    `
  },
  {
    category: "Literature",
    htext: "Sangeet Natak Akademi Fellowship (Akademi Ratna)",
    ptext: "A prestigious fellowship honouring lifetime achievement in performing arts.",
    img1: img3,
    ialt: "Sangeet Natak Akademi Fellowship",
    modalContent: `
      <b>Established:</b>1954</br>
        <b>Type:</b> Lifetime fellowship; highest honour of the Akademi.<br/>
        <b>First Awarded:</b>1954</br>
        <b>First Recipient: </b>Ariyakudi Ramanuja Iyengar, Karaikudi Sambasiva Iyer and Prithviraj Kapoor</br>
        <b> Symbolism:</b>Recognises a lifetime of pre‑eminent service to Indian performing arts</br>
        <b> Awarded For:</b>Eminence and lifetime achievement in music, dance, drama and related fields</br>
        <br/><b><a href='https://en.wikipedia.org/wiki/Sangeet_Natak_Akademi_Fellowship'>wiki link</a></b> 
    `
  },
  {
    category: "Literature",
    htext: "Bharatiya Jnanpeeth Navlekhan Award",
    ptext: "Award for emerging Hindi writers for their first major work.",
    img1: img4,
    ialt: "Navlekhan Award",
    modalContent: `
      <b>Established:</b>2006</br>
              <b>Type:</b>First-work award (for debut / formative literary works by young writers) in Hindi.<br/>
              <b>First Awarded:</b>2006</br>
              <b>First Recipient: </b>Saumitra Saxena (for his work Mitra)</br>
              <b> Symbolism:</b>The Saraswati statue symbolizes knowledge, learning and literary creativity — a fitting emblem for a literary award honoring new writers.</br>
              <b> Awarded For:</b>Debut or first-ever creation(s) by young Hindi authors — short stories, novels, poetry, non-fiction etc.</br> 
              <br/><b><a href='https://en.wikipedia.org/wiki/Bharatiya_Jnanpeeth_Navlekhan_Award'>wiki link</a></b>
    `
  },
  {
    category: "Literature",
    htext: "Saraswati Samman",
    ptext: "Honours outstanding literary works in Indian languages.",
    img1: img5,
    ialt: "Saraswati Samman",
    modalContent: `
      <b>Established:</b>1991</br>
              <b>Type:</b>Book-specific literary award (for a specific work).<br/>
              <b>First Awarded:</b>1991</br>
              <b>First Recipient: </b>Harivansh Rai Bachchan — for his four-volume autobiography.</br>
              <b> Symbolism:</b>Named after goddess Saraswati — symbolising learning, wisdom and creative arts.</br>
              <b> Awarded For:</b>Outstanding literary work (prose or poetry) written in any Indian language (from Schedule VIII) and published within last 10 years.</br> 
              <br/><b><a href='https://en.wikipedia.org/wiki/Saraswati_Samman'>wiki link</a></b>
    `
  },
  {
    category: "Literature",
    htext: "Vyas Samman",
    ptext: "Recognises an outstanding Hindi literary work published in the last decade.",
    img1: img6,
    ialt: "Vyas Samman",
    modalContent: `
      <b>Established:</b>1991</br>
              <b>Type:</b>Book-specific literary award (for a recent work).<br/>
              <b>First Awarded:</b>1991</br>
              <b>First Recipient: </b>Ram Vilas Sharma — for his work The Ancient Language Family of India and Hindi.</br>
              <b> Symbolism:</b>The memento and recognition symbolise excellence in Hindi literature — promoting Hindi literary writing.</br>
              <b> Awarded For:</b>Outstanding literary work written in Hindi and published within 10 years before the award.</br> 
              <br/><b><a href='https://en.wikipedia.org/wiki/Vyas_Samman'>wiki link</a></b> 
    `
  },
  {
    category: "Literature",
    htext: "Kabir Samman",
    ptext: "Award for excellence in poetry and literary contribution.",
    img1: img7,
    ialt: "Kabir Samman",
    modalContent: `
      <b>Established:</b>1986</br>
              <b>Type:</b>Literary award (book or body of poetry / literary contribution).<br/>
              <b>First Awarded:</b>1987</br>
              <b>First Recipient: </b>Gopal Krishna Adiga.</br>
              <b> Symbolism:</b>Named after Kabir Das — the famous saint-poet — symbolising deep poetic tradition and spiritual-social poetry excellence.</br>
              <b> Awarded For:</b>Outstanding poetry / literary contribution in Indian languages — usually poetry/poetic works.</br> 
              <br/><b><a href='https://en.wikipedia.org/wiki/Kabir_Samman'>wiki link</a></b> 
    `
  }
];

/* ----------------- Component Page ----------------- */

export default function LitAwards() {
  return (
    <div>
      <h1 className="heading">Literature Awards</h1>
      <h3 className="head2">“Honoring the voices that shape India's literary imagination.”</h3>

      <div className="search-cards-container">
        {literatureAwardsData.map((award, i) => (
          <Cards
            key={i}
            htext={award.htext}
            ptext={award.ptext}
            img1={award.img1}
            ialt={award.ialt}
            btext="learn more"
            modalContent={award.modalContent}
          />
        ))}
      </div>
    </div>
  );
}
